import React from "react";

import * as R from "ramda";
import { Rifm } from "rifm";
import isFunction from "is-function";
import Eye from "react-icons/lib/fa/eye";
import EyeSlash from "react-icons/lib/fa/eye-slash";
import { colors } from "src/styles";

import { Flex, Input, Text } from "src/components";

import ValidationIcon from "./ValidationIcon";
import FloatingLabel from "./FloatingLabel";
import { useEffect } from "react";

const formInputProps = props => {
  const floating = Boolean((props.value || props.error) && props.label);

  const errorOrPlaceholder =
    !props.value && props.error ? props.error : props.placeholder;

  return {
    pb: floating && !props.labelTop ? "8px" : 2,
    pt: floating && !props.labelTop ? "24px" : 2,
    pr: 3,
    pl: props.renderLeftIcon ? [3, "48px"] : [2, 3],
    borderRadius: 5,
    placeholderColor: props.error && "alert",
    flex: 1,
    title: props.placeholder,
    fontWeight: props.numeric ? "300" : "400",
    ...R.omit(["onTouch", "required"], props),
    placeholder: props.labelTop ? props.placeholder : errorOrPlaceholder,
    fontSize: props.fontSize || [3, 4],
  };
};

const FormInput = props => {
  // TODO: See if setting flex to 1 1 auto insead of 1 0 auto causes problems in IE 11
  const floating = Boolean((props.value || props.error) && props.label);
  const renderLabelAbove = props.labelTop;
  const renderLabelInside = floating && !props.labelTop;

  const [showPassword, setShowPassword] = React.useState(false);

  useEffect(() => {
    if (props.type !== "password" || !props.allowToggleVisibility) {
      return;
    }
    const input = document.getElementById(props.id);
    if (input == null || input == undefined) {
      return;
    }
    if (showPassword) {
      input.type = "text";
    } else {
      input.type = "password";
    }
  }, [showPassword]);

  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <Flex flex="1 1 auto" flexDirection="column" mb={2} {...props.displayProps}>
      {renderLabelAbove && (
        <FloatingLabel
          fontSize={[2, 3]}
          position={{
            position: "static",
          }}
          ml={[2, 3]}
        >
          {props.label}
        </FloatingLabel>
      )}
      <Flex align="center" style={{ position: "relative" }}>
        {props.renderLeftIcon &&
          props.renderLeftIcon({
            style: {
              position: "absolute",
              left: [10, 20],
              top: 0,
              bottom: 0,
              align: "center",
            },
          })}

        {props.format && isFunction(props.format) ? (
          <Rifm {...props} onChange={props.setValue} value={props.value}>
            {({ value, onChange }) => (
              <Input
                {...formInputProps(props)}
                onChange={onChange}
                value={value}
              />
            )}
          </Rifm>
        ) : (
          <Input {...formInputProps(props)} />
        )}
        {props.type === "password" && props.allowToggleVisibility && (
          <Flex
            style={{
              margin: "1rem 2rem",
              cursor: "pointer",
              right: "35px",
              position: "absolute",
            }}
          >
            {showPassword ? (
              <EyeSlash
                onClick={handleTogglePassword}
                size={24}
                color={colors.muted}
                flex={1}
              />
            ) : (
              <Eye
                onClick={handleTogglePassword}
                size={24}
                color={colors.muted}
                flex={1}
              />
            )}
          </Flex>
        )}
        <ValidationIcon
          {...props}
          position="absolute"
          right={[15, 20]}
          top={[18, 20]}
        />
        {props.renderRightIcon &&
          props.renderRightIcon({
            style: {
              position: "absolute",
              right: [10, 20],
              top: 0,
              bottom: 0,
              align: "center",
            },
          })}
        {renderLabelInside && (
          <FloatingLabel
            fontSize={[2, 3]}
            left={props.renderLeftIcon ? [32, 48] : [16, 32]}
            hasLeftIcon={Boolean(props.renderLeftIcon)}
            style={{ pointerEvents: "none" }}
          >
            {props.label}
          </FloatingLabel>
        )}
      </Flex>
      {props.renderHelpText &&
        props.renderHelpText({
          containerProps: {
            ml: [2, 3],
            mt: 1,
            mb: 2,
          },
        })}
    </Flex>
  );
};

FormInput.suppressInlineError = true;

export default FormInput;



// WEBPACK FOOTER //
// ./src/components/Form/Input.js